import { CachedOutlineIcon, UnClickIcon } from '@carboncopyco/icons';
import { NavigationEditSchemaType } from '@carboncopyco/types';
import type { RuleSelectionOption } from '../RuleSelectionPopover';

type RuleOption =
  | NavigationEditSchemaType.blockInteractions
  | NavigationEditSchemaType.replaceLink;
export const navigationRuleOptions: RuleSelectionOption<RuleOption>[] = [
  {
    value: NavigationEditSchemaType.blockInteractions,
    icon: <UnClickIcon />,
    label: 'Block',
  },
  {
    value: NavigationEditSchemaType.replaceLink,
    icon: <CachedOutlineIcon />,
    label: 'Replace',
  },
];
